import React from "react";
import { Card, CardContent, CardHeader } from "@material-ui/core";
import CRUDClassroom from "../CRUD/CRUDClassroom";
import { ClassroomDto } from "../../api-clients/api";
import { useTranslation } from "react-i18next";

export default function NewClassroom() {
  const { t } = useTranslation();
  return (
    <Card>
      <CardHeader title={t("classrooms.createTitle")} />
      <CardContent>
        <CRUDClassroom classroom={{} as ClassroomDto} />
      </CardContent>
    </Card>
  );
}
